import React, { useEffect, useState } from 'react';
import Burger from '../hamburger/Burger';
import CustomLink from './CostumLink';
import DropDown from './DropDown';
import Logo from './Logo';

export default function Navbar(props){
    const [isActive, setIsActive] = useState(false);
    const [isWidth, setIsWidth] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const toggleHamburger = () => {
        setIsOpen(!isOpen)
        setIsActive(!isActive);
    }
    
    const handleScreenWidth = () => {
        if(window.innerWidth > 991){
            setIsWidth(true);
        }else{
            setIsWidth(false);
        }
    }

    useEffect(() => {
        handleScreenWidth();
    }, [])

    return(
        <nav className={isActive ? 'nav nav-open' : props.class}>
            <Logo to="/" text="MAYA STERLING" />
            
            <ul className={isActive ? 'active' : ''}>
                <CustomLink to="/" text="HOME" onClick={toggleHamburger} />
                <CustomLink to="/portfolio" text="PORTFOLIO" onClick={toggleHamburger} />
                <CustomLink to="/gallery" text="GALLERY" onClick={toggleHamburger} />
                {isWidth ? <CustomLink to="#" text="|" /> : ''}
                <span className='dropdown'>
                        <span className='dropdown-link'>ABOUT</span>
                        <div className='dropdown-content'>
                            <DropDown onClick={toggleHamburger} />
                        </div>
                </span>                
            </ul>
            <Burger toggle={toggleHamburger} isOpen={isOpen} />
        </nav>
    );
}